export enum PurchaseType {
	BuyCard,
	RechargeBalance,
}
